import Link from 'next/link';
import { signOut } from 'next-auth/react';

const handleLogout = async () => {
  await signOut({ callbackUrl: '/' });
  // No need for window.location.reload() as the redirect will happen automatically
};

export default function UserMenu({ onLinkClick }) {
  return (
    <nav className='flex flex-col divide-y divide-gray-50 pb-2'>
      <Link
        href="/dashboard/user"
        className="flex items-center px-5 py-3 text-sm font-semibold text-gray-700 hover:bg-brand-primary/5 hover:text-brand-primary transition-colors group"
        onClick={onLinkClick}
      >
        <div className="w-8 h-8 rounded-lg bg-gray-50 flex items-center justify-center mr-3 group-hover:bg-brand-primary/10 transition-colors">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
          </svg>
        </div>
        Performance Dashboard
      </Link>

      <Link
        href="/dashboard/user/programs"
        className="flex items-center px-5 py-3 text-sm font-semibold text-gray-700 hover:bg-brand-primary/5 hover:text-brand-primary transition-colors group"
        onClick={onLinkClick}
      >
        <div className="w-8 h-8 rounded-lg bg-gray-50 flex items-center justify-center mr-3 group-hover:bg-brand-primary/10 transition-colors">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
          </svg>
        </div>
        My Programs
      </Link>

      <Link
        href="/dashboard/user/orders"
        className="flex items-center px-5 py-3 text-sm font-semibold text-gray-700 hover:bg-brand-primary/5 hover:text-brand-primary transition-colors group"
        onClick={onLinkClick}
      >
        <div className="w-8 h-8 rounded-lg bg-gray-50 flex items-center justify-center mr-3 group-hover:bg-brand-primary/10 transition-colors">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
          </svg>
        </div>
        Purchase History
      </Link>

      <Link
        href="/dashboard/user/edit-profile"
        className="flex items-center px-5 py-3 text-sm font-semibold text-gray-700 hover:bg-brand-primary/5 hover:text-brand-primary transition-colors group"
        onClick={onLinkClick}
      >
        <div className="w-8 h-8 rounded-lg bg-gray-50 flex items-center justify-center mr-3 group-hover:bg-brand-primary/10 transition-colors">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
        </div>
        Account Settings
      </Link>

      <div className="pt-2 mt-2">
        <button
          onClick={handleLogout}
          className="flex items-center w-full text-left px-5 py-3 text-sm font-bold text-rose-600 hover:bg-rose-50 transition-colors group"
        >
          <div className="w-8 h-8 rounded-lg bg-rose-50 flex items-center justify-center mr-3 group-hover:bg-rose-100 transition-colors">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
          </div>
          Logout System
        </button>
      </div>
    </nav>
  );
}
